import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_breadcrumbs, {
      items: [{ title: 'アルバム一覧', href: '/memoru/top', color:'primary' }, { title: '' }],
      class: "px-0"
    }),
    _cache[11] || (_cache[11] = _createElementVNode("h3", null, "アップロード", -1)),
    _createVNode(_component_v_form, {
      modelValue: _ctx.isFormValid,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isFormValid) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, { class: "pt-6" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _cache[6] || (_cache[6] = _createElementVNode("h5", null, "アルバム*", -1)),
                    _createVNode(_component_v_select, {
                      items: _ctx.albums ? _ctx.albums.items : [],
                      modelValue: _ctx.input.albumId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input.albumId) = $event)),
                      rules: [_ctx.required],
                      "item-title": "title",
                      "item-value": "albumId",
                      variant: "outlined",
                      "no-data-text": "読み込み中...",
                      disabled: _ctx.loading,
                      "hide-details": "",
                      density: "compact",
                      color: "primary"
                    }, null, 8, ["items", "modelValue", "rules", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _cache[7] || (_cache[7] = _createElementVNode("h5", null, "撮影日*", -1)),
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.input.date,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.input.date) = $event)),
                      rules: [_ctx.required],
                      disabled: _ctx.loading,
                      variant: "outlined",
                      "hide-details": "",
                      density: "compact",
                      type: "date",
                      color: "primary"
                    }, null, 8, ["modelValue", "rules", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _cache[8] || (_cache[8] = _createElementVNode("h5", null, "カテゴリ*", -1)),
                    _createVNode(_component_v_select, {
                      items: _ctx.multimediaCategoryType,
                      rules: [_ctx.required],
                      modelValue: _ctx.input.category,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.input.category) = $event)),
                      disabled: _ctx.loading,
                      variant: "outlined",
                      "hide-details": "",
                      density: "compact",
                      color: "primary"
                    }, null, 8, ["items", "rules", "modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              onDragover: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
              onDrop: _ctx.onDrop
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _cache[9] || (_cache[9] = _createElementVNode("h5", { class: "mb-2" }, "ファイルを選択*", -1)),
                    _createVNode(_component_v_file_input, {
                      modelValue: _ctx.files,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.files) = $event)),
                      disabled: _ctx.loading,
                      rules: [_ctx.required],
                      label: "ドラッグ&ドロップで追加",
                      class: "pt-1",
                      variant: "outlined",
                      "hide-details": "",
                      density: "compact",
                      height: "120px",
                      multiple: "",
                      color: "primary"
                    }, {
                      selection: _withCtx(({ fileNames }) => [
                        (fileNames.length === 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(fileNames[0]), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(fileNames.length) + "件のファイル", 1))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled", "rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onDrop"]),
            _createVNode(_component_v_row, { class: "pt-6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.clickUpload,
                      loading: _ctx.loading,
                      disabled: !_ctx.isFormValid,
                      color: "primary",
                      variant: "flat",
                      large: "",
                      block: ""
                    }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode(" アップロード ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "loading", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}